module.exports = "<li :class=\"['tab', disabled ? 'disabled' : '']\"> <a :class=\"active ? 'active' : ''\" :href=\"'#' + tabId\">{{label}}</a> <div :id=tabId> <slot></slot> </div> </li>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/tabs/tab.vue
 ** module id = 333
 ** module chunks = 0
 **/